import styled from 'styled-components'
import { FlexImageParameters } from '../../../api/generated'
import { Size2dLogicalPixels } from '../../../types/Size2d'
import { MainImageControlPanel } from './MainImageControlPanel'
import { MainImage } from './MainImage'
import { MainImageViewSelector } from './MainImageViewSelector'
import { GuidedViewPageType } from '../../../store/types'

const MainImageAreaRoot = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`

const ImageAndControlsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

/**
 * A separate type for CSS/logical pixels. The type BoundingBox2d in the
 * generated client code is using physical pixels and we do not want to
 * accidentally mix them up.
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio
 *
 * TODO: Rename the API type BoundingBox2d to BoundingBox2dPhysicalPixels.
 */
export interface BoundingBox2dLogicalPixels {
  logicalPosX: number
  logicalPosY: number
  logicalWidth: number
  logicalHeight: number
}

export interface ImageBoundingBoxState {
  wipers: BoundingBox2dLogicalPixels
  truckWithoutShadow: BoundingBox2dLogicalPixels
}

export interface ImageState {
  imageRootSize: Size2dLogicalPixels
  imageParams: FlexImageParameters
  url: string
  boundingBoxes: ImageBoundingBoxState | null
}

interface MainImageAreaProps {
  showImageControlPanel: boolean
  showSideArrows: boolean
  imageControlPanelHidden?: boolean
  showFullViewIcon: boolean
  navigateToMenu: (
    id: string,
    menuPath: string,
    gvPageToJumpTo: GuidedViewPageType,
  ) => void
}

export function MainImageArea({
  showImageControlPanel,
  showSideArrows,
  navigateToMenu,
  imageControlPanelHidden,
  showFullViewIcon,
}: MainImageAreaProps): JSX.Element {
  return (
    <MainImageAreaRoot>
      {showImageControlPanel && showSideArrows && (
        <MainImageViewSelector direction="left" />
      )}
      <ImageAndControlsWrapper>
        <MainImage
          navigateToMenu={navigateToMenu}
          hideCampaign={imageControlPanelHidden}
        />
        {showImageControlPanel && (
          <MainImageControlPanel
            imageControlPanelHidden={imageControlPanelHidden}
            showFullViewIcon={showFullViewIcon}
          />
        )}
      </ImageAndControlsWrapper>
      {showImageControlPanel && showSideArrows && (
        <MainImageViewSelector direction="right" />
      )}
    </MainImageAreaRoot>
  )
}
